/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZeropsRouteImport } from './routes/zerops'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PairRouteImport } from './routes/pair'
import { Route as KitRouteImport } from './routes/kit'
import { Route as GitRouteImport } from './routes/git'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as ZeropsNewRouteImport } from './routes/zerops_.new'
import { Route as ZeropsAuthorizedRouteImport } from './routes/zerops_.authorized'
import { Route as SettingsZeropsRouteImport } from './routes/settings.zerops'
import { Route as SettingsTeamRouteImport } from './routes/settings.team'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsAutomationRouteImport } from './routes/settings.automation'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as ProjectsProjectKeyRouteImport } from './routes/projects.$projectKey'
import { Route as ChatChiefRouteImport } from './routes/_chat.chief'
import { Route as SettingsTeamInviteRouteImport } from './routes/settings.team_.invite'
import { Route as SettingsTeamClientUserIdRouteImport } from './routes/settings.team_.$clientUserId'
import { Route as ChatMateProjectIdRouteImport } from './routes/_chat.mate.$projectId'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'
import { Route as ChatMateNewBirthIdRouteImport } from './routes/_chat.mate.new.$birthId'
import { Route as ChatGroupGroupIdFlowRouteImport } from './routes/_chat.group.$groupId.flow'
import { Route as ChatGroupGroupIdProjectIdRouteImport } from './routes/_chat.group.$groupId.$projectId'
import { Route as ChatChangeGroupIdRepositoryNumberRouteImport } from './routes/_chat.change.$groupId.$repository.$number'

const ZeropsRoute = ZeropsRouteImport.update({
  id: '/zerops',
  path: '/zerops',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const KitRoute = KitRouteImport.update({
  id: '/kit',
  path: '/kit',
  getParentRoute: () => rootRouteImport,
} as any)
const GitRoute = GitRouteImport.update({
  id: '/git',
  path: '/git',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const ZeropsNewRoute = ZeropsNewRouteImport.update({
  id: '/zerops_/new',
  path: '/zerops/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ZeropsAuthorizedRoute = ZeropsAuthorizedRouteImport.update({
  id: '/zerops_/authorized',
  path: '/zerops/authorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsZeropsRoute = SettingsZeropsRouteImport.update({
  id: '/zerops',
  path: '/zerops',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTeamRoute = SettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAutomationRoute = SettingsAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsProjectKeyRoute = ProjectsProjectKeyRouteImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatChiefRoute = ChatChiefRouteImport.update({
  id: '/chief',
  path: '/chief',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsTeamInviteRoute = SettingsTeamInviteRouteImport.update({
  id: '/team_/invite',
  path: '/team/invite',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTeamClientUserIdRoute =
  SettingsTeamClientUserIdRouteImport.update({
    id: '/team_/$clientUserId',
    path: '/team/$clientUserId',
    getParentRoute: () => SettingsRoute,
  } as any)
const ChatMateProjectIdRoute = ChatMateProjectIdRouteImport.update({
  id: '/mate/$projectId',
  path: '/mate/$projectId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatMateNewBirthIdRoute = ChatMateNewBirthIdRouteImport.update({
  id: '/mate/new/$birthId',
  path: '/mate/new/$birthId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatGroupGroupIdFlowRoute = ChatGroupGroupIdFlowRouteImport.update({
  id: '/group/$groupId/flow',
  path: '/group/$groupId/flow',
  getParentRoute: () => ChatRoute,
} as any)
const ChatGroupGroupIdProjectIdRoute =
  ChatGroupGroupIdProjectIdRouteImport.update({
    id: '/group/$groupId/$projectId',
    path: '/group/$groupId/$projectId',
    getParentRoute: () => ChatRoute,
  } as any)
const ChatChangeGroupIdRepositoryNumberRoute =
  ChatChangeGroupIdRepositoryNumberRouteImport.update({
    id: '/change/$groupId/$repository/$number',
    path: '/change/$groupId/$repository/$number',
    getParentRoute: () => ChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/git': typeof GitRoute
  '/kit': typeof KitRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/zerops': typeof ZeropsRoute
  '/chief': typeof ChatChiefRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/zerops': typeof SettingsZeropsRoute
  '/zerops/authorized': typeof ZeropsAuthorizedRoute
  '/zerops/new': typeof ZeropsNewRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/mate/$projectId': typeof ChatMateProjectIdRoute
  '/settings/team/$clientUserId': typeof SettingsTeamClientUserIdRoute
  '/settings/team/invite': typeof SettingsTeamInviteRoute
  '/group/$groupId/$projectId': typeof ChatGroupGroupIdProjectIdRoute
  '/group/$groupId/flow': typeof ChatGroupGroupIdFlowRoute
  '/mate/new/$birthId': typeof ChatMateNewBirthIdRoute
  '/change/$groupId/$repository/$number': typeof ChatChangeGroupIdRepositoryNumberRoute
}
export interface FileRoutesByTo {
  '/git': typeof GitRoute
  '/kit': typeof KitRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/zerops': typeof ZeropsRoute
  '/chief': typeof ChatChiefRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/zerops': typeof SettingsZeropsRoute
  '/zerops/authorized': typeof ZeropsAuthorizedRoute
  '/zerops/new': typeof ZeropsNewRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/mate/$projectId': typeof ChatMateProjectIdRoute
  '/settings/team/$clientUserId': typeof SettingsTeamClientUserIdRoute
  '/settings/team/invite': typeof SettingsTeamInviteRoute
  '/group/$groupId/$projectId': typeof ChatGroupGroupIdProjectIdRoute
  '/group/$groupId/flow': typeof ChatGroupGroupIdFlowRoute
  '/mate/new/$birthId': typeof ChatMateNewBirthIdRoute
  '/change/$groupId/$repository/$number': typeof ChatChangeGroupIdRepositoryNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/git': typeof GitRoute
  '/kit': typeof KitRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/usage': typeof UsageRoute
  '/zerops': typeof ZeropsRoute
  '/_chat/chief': typeof ChatChiefRoute
  '/projects/$projectKey': typeof ProjectsProjectKeyRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/automation': typeof SettingsAutomationRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/settings/team': typeof SettingsTeamRoute
  '/settings/zerops': typeof SettingsZeropsRoute
  '/zerops_/authorized': typeof ZeropsAuthorizedRoute
  '/zerops_/new': typeof ZeropsNewRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
  '/_chat/mate/$projectId': typeof ChatMateProjectIdRoute
  '/settings/team_/$clientUserId': typeof SettingsTeamClientUserIdRoute
  '/settings/team_/invite': typeof SettingsTeamInviteRoute
  '/_chat/group/$groupId/$projectId': typeof ChatGroupGroupIdProjectIdRoute
  '/_chat/group/$groupId/flow': typeof ChatGroupGroupIdFlowRoute
  '/_chat/mate/new/$birthId': typeof ChatMateNewBirthIdRoute
  '/_chat/change/$groupId/$repository/$number': typeof ChatChangeGroupIdRepositoryNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/git'
    | '/kit'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/zerops'
    | '/chief'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/automation'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/team'
    | '/settings/zerops'
    | '/zerops/authorized'
    | '/zerops/new'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/mate/$projectId'
    | '/settings/team/$clientUserId'
    | '/settings/team/invite'
    | '/group/$groupId/$projectId'
    | '/group/$groupId/flow'
    | '/mate/new/$birthId'
    | '/change/$groupId/$repository/$number'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/git'
    | '/kit'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/zerops'
    | '/chief'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/automation'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/team'
    | '/settings/zerops'
    | '/zerops/authorized'
    | '/zerops/new'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
    | '/mate/$projectId'
    | '/settings/team/$clientUserId'
    | '/settings/team/invite'
    | '/group/$groupId/$projectId'
    | '/group/$groupId/flow'
    | '/mate/new/$birthId'
    | '/change/$groupId/$repository/$number'
  id:
    | '__root__'
    | '/_chat'
    | '/git'
    | '/kit'
    | '/pair'
    | '/settings'
    | '/usage'
    | '/zerops'
    | '/_chat/chief'
    | '/projects/$projectKey'
    | '/settings/appearance'
    | '/settings/archived'
    | '/settings/automation'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/general'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/settings/team'
    | '/settings/zerops'
    | '/zerops_/authorized'
    | '/zerops_/new'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
    | '/_chat/mate/$projectId'
    | '/settings/team_/$clientUserId'
    | '/settings/team_/invite'
    | '/_chat/group/$groupId/$projectId'
    | '/_chat/group/$groupId/flow'
    | '/_chat/mate/new/$birthId'
    | '/_chat/change/$groupId/$repository/$number'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  GitRoute: typeof GitRoute
  KitRoute: typeof KitRoute
  PairRoute: typeof PairRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  UsageRoute: typeof UsageRoute
  ZeropsRoute: typeof ZeropsRoute
  ProjectsProjectKeyRoute: typeof ProjectsProjectKeyRoute
  ZeropsAuthorizedRoute: typeof ZeropsAuthorizedRoute
  ZeropsNewRoute: typeof ZeropsNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/zerops': {
      id: '/zerops'
      path: '/zerops'
      fullPath: '/zerops'
      preLoaderRoute: typeof ZeropsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kit': {
      id: '/kit'
      path: '/kit'
      fullPath: '/kit'
      preLoaderRoute: typeof KitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/git': {
      id: '/git'
      path: '/git'
      fullPath: '/git'
      preLoaderRoute: typeof GitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/zerops_/new': {
      id: '/zerops_/new'
      path: '/zerops/new'
      fullPath: '/zerops/new'
      preLoaderRoute: typeof ZeropsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zerops_/authorized': {
      id: '/zerops_/authorized'
      path: '/zerops/authorized'
      fullPath: '/zerops/authorized'
      preLoaderRoute: typeof ZeropsAuthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/zerops': {
      id: '/settings/zerops'
      path: '/zerops'
      fullPath: '/settings/zerops'
      preLoaderRoute: typeof SettingsZeropsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/team': {
      id: '/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof SettingsTeamRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/automation': {
      id: '/settings/automation'
      path: '/automation'
      fullPath: '/settings/automation'
      preLoaderRoute: typeof SettingsAutomationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$projectKey': {
      id: '/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof ProjectsProjectKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/chief': {
      id: '/_chat/chief'
      path: '/chief'
      fullPath: '/chief'
      preLoaderRoute: typeof ChatChiefRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/team_/invite': {
      id: '/settings/team_/invite'
      path: '/team/invite'
      fullPath: '/settings/team/invite'
      preLoaderRoute: typeof SettingsTeamInviteRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/team_/$clientUserId': {
      id: '/settings/team_/$clientUserId'
      path: '/team/$clientUserId'
      fullPath: '/settings/team/$clientUserId'
      preLoaderRoute: typeof SettingsTeamClientUserIdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/_chat/mate/$projectId': {
      id: '/_chat/mate/$projectId'
      path: '/mate/$projectId'
      fullPath: '/mate/$projectId'
      preLoaderRoute: typeof ChatMateProjectIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/mate/new/$birthId': {
      id: '/_chat/mate/new/$birthId'
      path: '/mate/new/$birthId'
      fullPath: '/mate/new/$birthId'
      preLoaderRoute: typeof ChatMateNewBirthIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/group/$groupId/flow': {
      id: '/_chat/group/$groupId/flow'
      path: '/group/$groupId/flow'
      fullPath: '/group/$groupId/flow'
      preLoaderRoute: typeof ChatGroupGroupIdFlowRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/group/$groupId/$projectId': {
      id: '/_chat/group/$groupId/$projectId'
      path: '/group/$groupId/$projectId'
      fullPath: '/group/$groupId/$projectId'
      preLoaderRoute: typeof ChatGroupGroupIdProjectIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/change/$groupId/$repository/$number': {
      id: '/_chat/change/$groupId/$repository/$number'
      path: '/change/$groupId/$repository/$number'
      fullPath: '/change/$groupId/$repository/$number'
      preLoaderRoute: typeof ChatChangeGroupIdRepositoryNumberRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatChiefRoute: typeof ChatChiefRoute
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
  ChatMateProjectIdRoute: typeof ChatMateProjectIdRoute
  ChatGroupGroupIdProjectIdRoute: typeof ChatGroupGroupIdProjectIdRoute
  ChatGroupGroupIdFlowRoute: typeof ChatGroupGroupIdFlowRoute
  ChatMateNewBirthIdRoute: typeof ChatMateNewBirthIdRoute
  ChatChangeGroupIdRepositoryNumberRoute: typeof ChatChangeGroupIdRepositoryNumberRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatChiefRoute: ChatChiefRoute,
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
  ChatMateProjectIdRoute: ChatMateProjectIdRoute,
  ChatGroupGroupIdProjectIdRoute: ChatGroupGroupIdProjectIdRoute,
  ChatGroupGroupIdFlowRoute: ChatGroupGroupIdFlowRoute,
  ChatMateNewBirthIdRoute: ChatMateNewBirthIdRoute,
  ChatChangeGroupIdRepositoryNumberRoute:
    ChatChangeGroupIdRepositoryNumberRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsAutomationRoute: typeof SettingsAutomationRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
  SettingsTeamRoute: typeof SettingsTeamRoute
  SettingsZeropsRoute: typeof SettingsZeropsRoute
  SettingsTeamClientUserIdRoute: typeof SettingsTeamClientUserIdRoute
  SettingsTeamInviteRoute: typeof SettingsTeamInviteRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsAutomationRoute: SettingsAutomationRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
  SettingsTeamRoute: SettingsTeamRoute,
  SettingsZeropsRoute: SettingsZeropsRoute,
  SettingsTeamClientUserIdRoute: SettingsTeamClientUserIdRoute,
  SettingsTeamInviteRoute: SettingsTeamInviteRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  GitRoute: GitRoute,
  KitRoute: KitRoute,
  PairRoute: PairRoute,
  SettingsRoute: SettingsRouteWithChildren,
  UsageRoute: UsageRoute,
  ZeropsRoute: ZeropsRoute,
  ProjectsProjectKeyRoute: ProjectsProjectKeyRoute,
  ZeropsAuthorizedRoute: ZeropsAuthorizedRoute,
  ZeropsNewRoute: ZeropsNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
